<template>
  <div
    id="the-main-content"
    class="opc-succezz"
    :class="{
      'opc-succezz__no__promotes': !showPromotes,
      'opc-modal': $context.is.modal,
    }">
    <component :is="viewLayout">
      <slot v-if="$slots.default?.()" />
      <thanks v-else />
      <template #details>
        <component :is='orderDetails'/>
      </template>
      <template #feedback v-if='false'>
        <Feedback />
      </template>
      <template #promotes>
        <ZoomBasicIntroCard v-if="isZuoraOutage" />
        <Promotes v-else :show-promotes='showPromotes' />
      </template>
    </component>
  </div>
</template>

<script>
// make sure everything has a default fallback, so that it could be zero configuration
import ViewLayoutResponsive from './view-layout.responsive.vue';
import Details from './details';
import DetailsMobile from './details.m.vue';
import Promotes from './promotes/promotes.vue';
import ZoomBasicIntroCard from './thanks-template/zoom-basic-intro-card.vue';
import Thanks from './thanks-template';
import Feedback from '@/views/succezz/feedback.vue';
import ViewLayoutModal from '@/views/succezz/view-layout.modal.vue';
import { mapGetters } from 'vuex';
import { APM_PAYMENT_METHODS } from '@/common/constants';
export default {
  components: {
    Feedback,
    ViewLayoutResponsive,
    Thanks,
    MyDetails: Details,
    Promotes,
    DetailsMobile,
    ZoomBasicIntroCard,
    ViewLayoutModal
  },
  props: {
    showPromotes: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['successConfig', 'boughtPlans', 'persistState']),
    isZuoraOutage() {
      // ALTERNATIVE CREDIT CARD FOR ZUORA OUTAGE
      return this.persistState.confirmationDetails?.isZuoraOutage && this.persistState.confirmationDetails?.apmName === APM_PAYMENT_METHODS.ALTERNATIVE_CREDIT_CARD;
    },
    viewLayout() {
      return this.$context.is.modal ? 'ViewLayoutModal' : 'ViewLayoutResponsive';
    },
    orderDetails() {
      return this.is_desktop_reactive ? 'MyDetails' : 'DetailsMobile';
    },
  }
};
</script>

<style lang='scss'>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/_variables.scss';
.opc-succezz__no__promotes {
  padding-bottom: 100px;
}

.opc-succezz {
  &.opc-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    .opc-succezz-plan__actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      gap: 9px;

      .zbo-button + .zbo-button {
        margin-left: 0 !important;
      }
    }
  }
}

@include media(tablet) {
  .opc-succezz {
    display: flex;
    justify-content: center;

    .opc-succezz-layout {
      width: 600px;
    }
  }
}

@include media(mobile) {
  .opc-succezz-plan__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    .zbo-button {
      width: 100%;
    }
  }
}
</style>
